import React from "react";
import { useParams } from "react-router-dom";
import parser from "html-react-parser";
import { Container, Row } from "react-bootstrap";
import SearchAside from "../components/SearchAside";
import Panorama from "../components/Panorama";
import { useProfessionalRole } from "hooks/query";

export default function ProfessionalRole() {
    const { slug } = useParams();
    const { data, isSuccess, isLoading } = useProfessionalRole(slug);


    return (
        <>
            <Panorama />
            <Container fluid>
                <SearchAside>
                    <Container>
                        {isSuccess && (
                            <Row className="serchAsideChildren">{parser(data.content ?? "")}</Row>
                        )}
                    </Container>
                </SearchAside>
            </Container>
        </>
    );
}
